module.exports = __webpack_public_path__ + "img/landing5.15083a26.jpg";